import { useWatch } from 'react-hook-form';

import { Typography } from 'shared';

import {
  SessionSidebarFieldset,
  SessionSidebarFieldsetLabel,
} from 'features/sessions/components';
import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import { SessionAttendanceStatusType } from 'features/sessions/config/types';

export const SessionsFormAttendanceNotes = () => {
  const [attendance, attendanceNote]: [SessionAttendanceStatusType, string] =
    useWatch({
      name: ['attendance', 'attendanceNote'],
    });

  if (
    attendance !== SESSION_ATTENDANCE_STATUS.CANCELED &&
    attendance !== SESSION_ATTENDANCE_STATUS.RESCHEDULED
  ) {
    return null;
  }

  return (
    <SessionSidebarFieldset>
      <SessionSidebarFieldsetLabel>Notes/Reasons</SessionSidebarFieldsetLabel>
      <Typography>{attendanceNote}</Typography>
    </SessionSidebarFieldset>
  );
};
